var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.319,
    height: 16.426,
    viewBox: "0 0 12.319 16.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-download",
    "data-name": "Icon awesome-file-download",
    d: "M7.186,4.363V0H.77A.768.768,0,0,0,0,.77V15.656a.768.768,0,0,0,.77.77H11.549a.768.768,0,0,0,.77-.77V5.133H7.956A.772.772,0,0,1,7.186,4.363Zm2.453,6.781-3.093,3.07a.547.547,0,0,1-.771,0l-3.093-3.07a.513.513,0,0,1,.361-.878H5.133V7.7a.513.513,0,0,1,.513-.513H6.673a.513.513,0,0,1,.513.513v2.567H9.277A.513.513,0,0,1,9.639,11.144Zm2.456-7.775L8.954.225A.769.769,0,0,0,8.409,0h-.2V4.106h4.106v-.2A.767.767,0,0,0,12.095,3.369Z",
    fill: "#337dff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.84dee345026a8e7ab8636807a6933caf.svg";
export { ForwardRef as ReactComponent };